import {
  AccountManualType,
  accountManualType,
} from "@bitwarden/web-vault/app/models/types/account.types";

const defaultAccountIcon: AccountManualType = "bank";

export function accountTypeIcon(type: string | undefined | null): string {
  const isManualType = !!type && Object.prototype.hasOwnProperty.call(accountManualType, type);
  return `${isManualType ? type : defaultAccountIcon}-account`;
}

const imageExtensionPattern = /\.(svg|png|jpe?g|webp|gif)$/i;

export function localBasiqLogoPath(logoUrl: string | undefined | null): string {
  if (!logoUrl || typeof logoUrl !== "string") {
    return "";
  }
  // Extract filename from CDN URL (e.g., AU00501.svg from https://d388vpyfrt4zrj.cloudfront.net/AU00501.svg).
  // Some institutions (seen on Fiskil-sourced accounts) carry a raw institution id in this field
  // instead of a real logo URL — guard on a recognizable image extension so that doesn't get
  // rendered as a broken <img src>; the sprite fallback icon covers it instead.
  const logoFileName = logoUrl.split("/").pop();
  return logoFileName && imageExtensionPattern.test(logoFileName)
    ? `images/icons/basiq/${logoFileName}`
    : "";
}
